import TabPage from "./TabPage";
import RanksLevelsTable from "@components/RanksLevelsTable";

const Currency = () => (
    <TabPage tabKey="currency">
        <RanksLevelsTable />
    </TabPage>
);

export default Currency;
